<template>
<div class="container marketing">
  <div class="row">
          <div v-for="category in categories.listIcons"  class="col-lg-4 category-icon">
            <img class="rounded-circle" :src="category.imageList[0]" alt="Generic placeholder image" width="140" height="140">
            <h5>{{category.name}}</h5>
            <hr>
            <p><a class="btn btn-secondary" href="#" role="button" @click="selected(category)">
                Wybierz &raquo;</a></p>
          </div>
         
        </div>
</div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      categories: state => state.categories
    })
  },
  methods: {
    selected(category) {
      this.$store.dispatch("categories/selected", category);
      this.$emit("selected");
      this.$router.replace({ name: "searchPage" });
    }
  },
  beforeMount() {
    this.$store.dispatch("categories/requestData");
  }
};
</script>




// WEBPACK FOOTER //
// node_modules/redbay-b2b-categories/src/CategoriesIconsWelcome.vue